module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 78300.580ba291.png";